import {
  GROUPS_ADD_ROLE_TYPE,
  GROUPS_DELETE_ROLE_TYPE,
  GROUPS_GET_SUCCESS_TYPE,
  GROUPS_GET_TYPE,
  GROUPS_UPDATE_CONFIG_TYPE,
  GROUPS_UPDATE_ERROR_TYPE,
  GROUPS_UPDATE_ROLE_SUCCESS_TYPE,
  GROUPS_UPDATE_ROLE_TYPE,
  GROUPS_UPDATE_SUCCESS_TYPE,
  GROUPS_UPDATE_TYPE,
  GroupsAction,
} from './groups.actions';
import { GroupsState } from './groups.interfaces';

import cloneDeep from 'lodash-es/cloneDeep';
import findIndex from 'lodash-es/findIndex';
import remove from 'lodash-es/remove';

const INITIAL_STATE: GroupsState[] = [];

export function groupsReducer(
  state: any = INITIAL_STATE,
  action: GroupsAction,
): GroupsState[] {
  switch (action.type) {
    case GROUPS_GET_TYPE: {
      return [
        ...state,
        {
          document: {
            _id: action.payload.group._id,
            slug: action.payload.group.slug,
          },
          isLoaded: false,
        },
      ];
    }

    case GROUPS_GET_SUCCESS_TYPE: {
      const stateClone = [...state];
      const targetIndex = findIndex(stateClone, {
        document: { _id: action.payload.group._id },
      });
      const groupStateDocument = {
        document: action.payload.group,
        isLoaded: true,
      };
      if (0 > targetIndex) {
        stateClone.push(groupStateDocument);
      } else {
        stateClone[targetIndex] = groupStateDocument;
      }
      return stateClone;
    }

    case GROUPS_UPDATE_TYPE:
    case GROUPS_UPDATE_SUCCESS_TYPE:
    case GROUPS_UPDATE_ERROR_TYPE: {
      const stateUpdateClone = [...state];
      const targetUpdateIndex = findIndex(stateUpdateClone, {
        document: { _id: action.payload.group._id },
      });
      const updateTarget = { ...stateUpdateClone[targetUpdateIndex] };
      stateUpdateClone[targetUpdateIndex] = {
        ...updateTarget,
        document: {
          ...updateTarget.document,
          ...action.payload.group,
        },
      };
      return [...stateUpdateClone];
    }

    case GROUPS_UPDATE_CONFIG_TYPE: {
      const stateUpdateClone = [...state];
      const targetUpdateIndex = findIndex(stateUpdateClone, {
        document: { _id: action.payload.group._id },
      });
      const updateTarget = { ...stateUpdateClone[targetUpdateIndex] };
      stateUpdateClone[targetUpdateIndex] = {
        ...updateTarget,
        ...action.payload.update,
      };
      return [...stateUpdateClone];
    }

    case GROUPS_UPDATE_ROLE_TYPE: {
      const stateUpdateRoleClone = cloneDeep(state);
      const targetGroupIndex = findIndex(stateUpdateRoleClone, {
        document: {
          _id: action.payload.group._id,
        },
      });
      const targetGroup = stateUpdateRoleClone[targetGroupIndex].document;
      const targetRoleIndex = findIndex(targetGroup.roles, {
        _id: action.payload.role._id,
      });
      const targetRole = targetGroup.roles[targetRoleIndex];
      targetGroup.roles[targetRoleIndex] = {
        ...targetRole,
        ...action.payload.role,
      };
      return stateUpdateRoleClone;
    }

    case GROUPS_UPDATE_ROLE_SUCCESS_TYPE: {
      const stateUpdateRoleCallbackClone = cloneDeep(state);
      const targetGroupCallbackIndex = findIndex(stateUpdateRoleCallbackClone, {
        document: {
          _id: action.payload.group._id,
        },
      });
      const targetGroupCallback =
        stateUpdateRoleCallbackClone[targetGroupCallbackIndex].document;
      targetGroupCallback.roles = cloneDeep(action.payload.roles);
      return stateUpdateRoleCallbackClone;
    }

    case GROUPS_ADD_ROLE_TYPE: {
      const stateAddRoleClone = cloneDeep(state);
      const targetAddRoleGroupIndex = findIndex(stateAddRoleClone, {
        document: {
          _id: action.payload.group._id,
        },
      });
      const targetAddRoleGroup =
        stateAddRoleClone[targetAddRoleGroupIndex].document;
      targetAddRoleGroup.roles = [
        ...targetAddRoleGroup.roles,
        action.payload.role,
      ];
      return stateAddRoleClone;
    }

    case GROUPS_DELETE_ROLE_TYPE: {
      const stateDeleteRoleClone = cloneDeep(state);
      const targetDeleteRoleGroupIndex = findIndex(stateDeleteRoleClone, {
        document: {
          _id: action.payload.group._id,
        },
      });
      const targetDeleteRoleGroup =
        stateDeleteRoleClone[targetDeleteRoleGroupIndex].document;
      remove(targetDeleteRoleGroup.roles, { _id: action.payload.role._id });
      return stateDeleteRoleClone;
    }

    default: {
      return state;
    }
  }
}
